// reportTestIds.ts

import {Reports} from '/constant/TestIDs';
import {
  REPORT_CLOSE_TO_EXECUTIVE_DIRECTOR_RANK,
  REPORT_CLOSE_TO_FIBC_RANK,
  REPORT_CLOSE_TO_SENIOR_COACH_RANK,
  REPORT_COACHES_ABOVE_RANK,
  REPORT_COACHES_AT_RANK,
  REPORT_COACHES_BELOW_RANK,
  REPORT_EARNED_ACCELERATOR_BONUS,
  REPORT_EARNED_CLIENT_SUPPORT_BONUS_PLUS,
  REPORT_ELIGIBLE_ACCELERATOR_BONUS,
  REPORT_ELIGIBLE_CLIENT_SUPPORT_FIVE_SIX,
  REPORT_ELIGIBLE_CLIENT_SUPPORT_ONE_TWO,
  REPORT_ELIGIBLE_CLIENT_SUPPORT_SEVEN_NINE,
  REPORT_ELIGIBLE_CLIENT_SUPPORT_THREE_FOUR,
  REPORT_RANK_UP,
  REPORT_TEAMS_EXECUTIVE_DIRECTOR,
  REPORT_TEAMS_FIBC,
  REPORT_TEAMS_FIBL,
  REPORT_TEAMS_SENIOR_COACH,
} from '/enum/records.enum';

const COACH_RANK_REPORTS = [
  REPORT_EARNED_CLIENT_SUPPORT_BONUS_PLUS,
  REPORT_ELIGIBLE_CLIENT_SUPPORT_SEVEN_NINE,
  REPORT_ELIGIBLE_CLIENT_SUPPORT_FIVE_SIX,
  REPORT_ELIGIBLE_CLIENT_SUPPORT_THREE_FOUR,
  REPORT_ELIGIBLE_CLIENT_SUPPORT_ONE_TWO,
  REPORT_CLOSE_TO_FIBC_RANK,
  REPORT_CLOSE_TO_EXECUTIVE_DIRECTOR_RANK,
  REPORT_CLOSE_TO_SENIOR_COACH_RANK,
  REPORT_COACHES_AT_RANK,
  REPORT_COACHES_BELOW_RANK,
  REPORT_COACHES_ABOVE_RANK,
  REPORT_TEAMS_FIBL,
  REPORT_TEAMS_FIBC,
  REPORT_TEAMS_EXECUTIVE_DIRECTOR,
  REPORT_TEAMS_SENIOR_COACH,
];

const createCoachRankConfig = (reports: string[]) =>
  reports.reduce((acc, report) => {
    acc[report] = {
      isCoach: true,
      roleTestId: Reports.reportCoachRank,
    };
    return acc;
  }, {} as Record<string, {isCoach: boolean; roleTestId: string}>);

export const REPORT_CONFIG: Record<
  string,
  {
    isCoach: boolean;
    roleTestId?: string;
  }
> = {
  [REPORT_ELIGIBLE_ACCELERATOR_BONUS]: {
    isCoach: true,
    roleTestId: Reports.reportGeneration,
  },
  [REPORT_EARNED_ACCELERATOR_BONUS]: {
    isCoach: true,
    roleTestId: Reports.reportGeneration,
  },
  [REPORT_RANK_UP]: {
    isCoach: true,
    roleTestId: Reports.reportNewHraRank,
  },

  ...createCoachRankConfig(COACH_RANK_REPORTS),
};
